import { createContext } from 'use-context-selector'
import { InviteOrgMemberContextProps } from './types'
export const InviteOrgMemberContext = createContext(
  {} as InviteOrgMemberContextProps
)
